<template>
  <svg width="16" height="16" viewBox="0 0 16 16">
    <path
      d="m7.779 12.286-3.59 1.769a.5.5 0 0 1-.712-.539l.669-3.658a.5.5 0 0 0-.155-.46L1.18 6.83a.5.5 0 0 1 .27-.864l3.944-.537a.5.5 0 0 0 .375-.263l1.789-3.398a.5.5 0 0 1 .884 0l1.79 3.398a.5.5 0 0 0 .374.263l3.944.537a.5.5 0 0 1 .27.864L12.01 9.4a.5.5 0 0 0-.155.459l.67 3.658a.5.5 0 0 1-.714.539l-3.589-1.77a.5.5 0 0 0-.442 0z"
      fill="#000"
      fill-rule="evenodd"
    />
  </svg>
</template>
